import React from "react"

export default ({ title, icon }) => (
  <div className="domTitle">
    <div className="maxWidth">
      {" "}
      {icon}
      {title}
    </div>
  </div>
)
